// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__zfhso","montageImage":"Sidebar_montageImage__+oZJU"};